import { createContext } from "react";

const SuperAgentProvinceScreen = createContext<any>(null);

export default SuperAgentProvinceScreen;
